import { render, staticRenderFns } from "./TheInvestmentsAnalytics.vue?vue&type=template&id=600b8cd0&scoped=true&"
import script from "./TheInvestmentsAnalytics.vue?vue&type=script&lang=js&"
export * from "./TheInvestmentsAnalytics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "600b8cd0",
  null
  
)

export default component.exports